import { useState } from "react";
import { LoginFirstStep } from "../../../Services/Api/AuthRequests";
import { TbLogin2 } from "react-icons/tb";

const LoginFieldFirst = ({onSuccess, OnFail}) => {
    const [loginOrEmail, setLoginOrEmail] = useState("");
    const [password, setPassword] = useState("");

    const Login = () => {
        if(loginOrEmail && password)
          LoginFirstStep(loginOrEmail, password, onSuccess, OnFail);
      }

    return (
        <>
          <div className="usernameField loginField">
            <span className="pl-1">Nazwa użytkownika</span>
            <input className="input" onChange={(e) => setLoginOrEmail(e.target.value)} type="text"></input>
          </div>
          <div className="passwordField loginField">
            <span className="pl-1">Hasło</span>
            <input className="input" onChange={(e) => setPassword(e.target.value)} type="password"></input>
          </div>        
          <span className="text-glyellow text-center px-6 font-bold my-2">Upewnij się, że tylko Ty widzisz ekran!</span>
          <button onClick={Login} className="loginBtn mt-8"><TbLogin2 className="btnIcon"/>Zaloguj się</button>
        </>
    )
}

export default LoginFieldFirst;